import { graphql } from "@/graphql/codegen"

graphql(`
  fragment AssociatedTestTemplateFields on AssociatedTestTemplate {
    associatedTestTemplateId
    sequenceNumber
    testTemplate {
      description
      externalSystemId
      resultsUnitOfMeasure
      comparison
    }
    product {
      productId
    }
    maximumValue
    minimumValue
    equalToValue
    dataType
    printToAkrochem
    significantFigures
    isDeleted
  }
`)
